var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"br-notes-skel"},_vm._l((_vm.count),function(n){return _c('li',{key:n,staticClass:"br-notes-skel__row"},[_c('i'),_c('i'),_c('i'),_c('i')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }